import HBList from "@/components/HBList";
import PinCard from "@/components/PinCard";
import { usePinActionsWithCard } from "@/components/PinCard/actions/usePinActionWithCard";
import { useIsViolationAb } from "@/components/Violation/useIsViolationAb";
import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import { useMemoizedFn } from "ahooks";
import dynamic from "next/dynamic";
import { useCallback, useEffect, useState } from "react";
import styles from "./index.module.less";

const PinActions = dynamic(import("@/components/PinCard/actions"), {
  ssr: false,
});

export default function ImmersivePinList({
  hideUser,
  dataSource,
  showBoardLink,
  disableModal,
  disableQueue,
  disableFile,
  ...rest
}) {
  const { pinActionsProps, onMouseEnterCard, onMouseLeaveCard } =
    usePinActionsWithCard();
  const { user, pinOpenType, showPinDesc } = useAppStore(
    ({ user, pinOpenType, showPinDesc }) => ({ user, pinOpenType, showPinDesc })
  );

  const [deleteMap, setDeleteMap] = useState({});
  // 过滤已删除内容
  const filter = useCallback(
    (dataSource) => {
      return dataSource.filter((record) => {
        if (deleteMap[record.pin_id]) {
          return false;
        }
        if (record.file?.file_id) {
          return record.file_id === record.file.file_id;
        }
        return true;
      });
    },
    [deleteMap]
  );

  // 监听删除事件，记录删除的pin
  useEffect(() => {
    const onDelete = (evt) => {
      const pinIds = Array.isArray(evt.detail) ? evt.detail : [evt.detail];
      const nextMap = {};
      pinIds.forEach((pinId) => {
        nextMap[pinId] = true;
      });
      setDeleteMap({
        ...nextMap,
        ...deleteMap,
      });
    };
    window.addEventListener(EVENT.DELETE_PIN, onDelete);
    return () => {
      window.removeEventListener(EVENT.DELETE_PIN, onDelete);
    };
  }, [deleteMap]);

  // 设置详情弹框左右切换队列
  useEffect(() => {
    if (!disableQueue) {
      if (dataSource.length > 0) {
        const map = {};
        useAppStore.setState({
          pinQueue: dataSource.filter((item) => {
            if (map[item.pin_id] || item.type === "recommend") {
              return false;
            }
            map[item.pin_id] = true;
            if (deleteMap[item.pin_id]) {
              return false;
            }
            if (item.file?.file_id) {
              return item.file_id === item.file.file_id;
            }
            return true;
          }),
        });
      }
      return () => {
        useAppStore.setState({
          pinQueue: [],
        });
      };
    }
  }, [dataSource, deleteMap, disableQueue]);

  const violationAb = useIsViolationAb();

  const render = useMemoizedFn((record) => {
    return (
      <PinCard
        user={user}
        violationAb={violationAb}
        pinOpenType={pinOpenType}
        key={record.pin_id}
        record={record}
        showBoardLink={showBoardLink}
        disableModal={disableModal}
        disableFile={disableFile}
        hideUser={hideUser}
        showDesc={showPinDesc}
        fullWidth
        onMouseEnterCard={onMouseEnterCard}
        onMouseLeaveCard={onMouseLeaveCard}
      />
    );
  });

  return (
    <div className={styles.list}>
      <HBList
        disableMasonry={true}
        loginGuide={true}
        uniqueKey="pin_id"
        render={render}
        dataSource={dataSource}
        filter={filter}
        {...rest}
      />

      <PinActions {...pinActionsProps} fullWidth />
    </div>
  );
}
